import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-6 grid md:grid-cols-12 gap-y-4 gap-4" }
const _hoisted_2 = { class: "grid md:grid-cols-12 gap-y-4 gap-4 p-6 pt-4" }

import {
  MedKitButton,
  MedKitDateTimeField,
  MedKitFieldValidation,
  MedKitSearch,
  MedKitSelect,
  MedKitSwitch,
  MedKitTextField,
} from '@bigpicturemedical/medkit'
import { DvCodedTextList, DvCodedText, IPath, NodeRepeater, TerminologySearch, useWebTemplateHelpers, DvDateTime, DvText } from '@bigpicturemedical/openehr-vue'
import { useI18n } from 'vue-i18n'
import enGB from '../locale/en-GB.json'
import { BlockContainer, BlockHeader, BlockPanel, BlockPanelHeader, BlockWell } from './_layout'
import { BlockHeaderIntent } from './_layout/blockLayoutProps'

// define message schema for Vue component
type MessageSchema = typeof enGB

interface SearchOption {
  label: string
  value: unknown
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AllergiesBlock',
  props: {
    path: null,
    name: null,
    description: null,
    errors: null
  },
  setup(__props: any) {

const props = __props as {
  path: IPath
  name: string
  description: string
  errors: Array<string> // TODO: Display this
};



const { getData, getErrors } = useWebTemplateHelpers()

const { t } = useI18n<{message:MessageSchema}>()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BlockContainer), { class: "space-y-6" }, {
    default: _withCtx(() => [
      _createVNode(_unref(BlockHeader), {
        heading: _unref(t)('adverseReactions.name'),
        description: _unref(t)('adverseReactions.description')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DvCodedText), {
            path: props.path.add('exclusion_-_global.global_exclusion_of_adverse_reactions')
          }, {
            default: _withCtx(({ value, setValue, items }) => [
              _createVNode(_unref(MedKitSwitch), {
                class: "w-max",
                "model-value": !! value,
                label: _unref(t)('adverseReactions.globalExclusionOfAdverseReactions'),
                "label-position": "start",
                contained: "",
                "onUpdate:modelValue": ($event: any) => (setValue($event ? items[0] : undefined))
              }, null, 8, ["model-value", "label", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["path"])
        ]),
        _: 1
      }, 8, ["heading", "description"]),
      (_unref(getErrors)(props.path).length)
        ? (_openBlock(), _createBlock(_unref(MedKitFieldValidation), {
            key: 0,
            id: "allergies_error",
            text: _unref(getErrors)(props.path)[0]
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NodeRepeater), {
        path: props.path.add('adverse_reaction_risk'),
        reverse: "",
        "present-if": !_unref(getData)(props.path.add('exclusion_-_global.global_exclusion_of_adverse_reactions'))
      }, {
        header: _withCtx(({ addItem }) => [
          _createVNode(_unref(MedKitButton), {
            class: "w-full",
            kind: "repeater",
            label: _unref(t)('adverseReactions.adverseReactionRisk.add'),
            icon: "plus",
            "icon-position": "start",
            onClick: addItem
          }, null, 8, ["label", "onClick"])
        ]),
        default: _withCtx(({ index: adverseReactionRiskIndex, remove }) => [
          _createVNode(_unref(BlockPanel), null, {
            default: _withCtx(() => [
              _createVNode(_unref(BlockPanelHeader), {
                title: _unref(t)('adverseReactions.adverseReactionRisk.title')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MedKitButton), {
                    size: "small",
                    label: _unref(t)('adverseReactions.adverseReactionRisk.remove'),
                    "icon-position": "only",
                    icon: "delete",
                    onClick: remove
                  }, null, 8, ["label", "onClick"])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(DvCodedText), {
                  path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.substance`)
                }, {
                  default: _withCtx(({ name, terminology, value, setValue, errors, validate, required }) => [
                    _createVNode(_unref(TerminologySearch), { terminology: terminology }, {
                      default: _withCtx(({ search, searching, results, error: terminologySearchError }) => [
                        _createVNode(_unref(MedKitSearch), {
                          class: "col-span-12 md:col-span-6",
                          "model-value": value ? { label: value['|value'], value: value } : undefined,
                          error: terminologySearchError ?? errors[0],
                          label: name,
                          "is-loading": searching,
                          options: results.map(result => ({
                    label: result['|value'],
                    value: result,
                  })),
                          required: required,
                          "onUpdate:query": search,
                          "onUpdate:modelValue": ($event: any) => (setValue($event ? ($event as SearchOption).value : undefined)),
                          onInput: validate
                        }, null, 8, ["model-value", "error", "label", "is-loading", "options", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 2
                    }, 1032, ["terminology"])
                  ]),
                  _: 2
                }, 1032, ["path"]),
                _createVNode(_unref(DvCodedText), {
                  path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.status`)
                }, {
                  default: _withCtx(({ name, options, selected, setSelected, errors, validate, required }) => [
                    _createVNode(_unref(MedKitSelect), {
                      class: "col-span-12 sm:col-span-6 md:col-span-3",
                      error: errors[0],
                      label: name,
                      "model-value": selected,
                      options: options,
                      required: required,
                      "onUpdate:modelValue": setSelected,
                      onInput: validate
                    }, null, 8, ["error", "label", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
                  ]),
                  _: 2
                }, 1032, ["path"]),
                _createVNode(_unref(DvCodedText), {
                  path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.criticality`)
                }, {
                  default: _withCtx(({ name, options, selected, setSelected, errors, validate, required }) => [
                    _createVNode(_unref(MedKitSelect), {
                      class: "col-span-12 sm:col-span-6 md:col-span-3",
                      error: errors[0],
                      label: name,
                      "model-value": selected,
                      options: options,
                      required: required,
                      "onUpdate:modelValue": setSelected,
                      onInput: validate
                    }, null, 8, ["error", "label", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
                  ]),
                  _: 2
                }, 1032, ["path"])
              ]),
              _createVNode(_unref(BlockWell), { class: "col-span-12 space-y-6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NodeRepeater), {
                    path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.reaction_event`),
                    reverse: ""
                  }, {
                    header: _withCtx(({ addItem }) => [
                      _createVNode(_unref(MedKitButton), {
                        class: "w-full",
                        block: "",
                        kind: "repeater",
                        size: "medium",
                        label: _unref(t)('adverseReactions.reactionEvent.add'),
                        icon: "plus",
                        "icon-position": "start",
                        onClick: addItem
                      }, null, 8, ["label", "onClick"])
                    ]),
                    default: _withCtx(({ index: reactionEventIndex, remove: removeReactionEvent, count }) => [
                      _createVNode(_unref(BlockPanel), { class: "space-y-4" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BlockPanelHeader), {
                            title: _unref(t)('adverseReactions.reactionEvent.title'),
                            icon: "calendar",
                            intent: _unref(BlockHeaderIntent).secondary
                          }, {
                            default: _withCtx(() => [
                              (count > 1)
                                ? (_openBlock(), _createBlock(_unref(MedKitButton), {
                                    key: 0,
                                    class: "",
                                    label: _unref(t)('adverseReactions.reactionEvent.remove'),
                                    "icon-position": "only",
                                    icon: "delete",
                                    size: "small",
                                    onClick: removeReactionEvent
                                  }, null, 8, ["label", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["title", "intent"]),
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(DvCodedTextList), {
                              path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.reaction_event.${reactionEventIndex}.manifestation`)
                            }, {
                              default: _withCtx(({ name, values, setValues, terminology, errors, validate, required }) => [
                                _createVNode(_unref(TerminologySearch), { terminology: terminology }, {
                                  default: _withCtx(({ search, results, searching, error: terminologySearchError }) => [
                                    _createVNode(_unref(MedKitSearch), {
                                      multiple: "",
                                      label: name,
                                      "model-value": values.map(value => ({
                            label: value['|value'],
                            value: value,
                          })),
                                      options: results.map(result => ({
                            label: result['|value'],
                            value: result,
                          })),
                                      "is-loading": searching,
                                      error: terminologySearchError ?? errors[0],
                                      required: required,
                                      class: "col-span-12",
                                      "onUpdate:query": search,
                                      "onUpdate:modelValue": ($event: any) => (setValues(($event as SearchOption[]).map(value => value.value))),
                                      onInput: validate
                                    }, null, 8, ["label", "model-value", "options", "is-loading", "error", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                                  ]),
                                  _: 2
                                }, 1032, ["terminology"])
                              ]),
                              _: 2
                            }, 1032, ["path"]),
                            _createVNode(_unref(DvCodedText), {
                              path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.reaction_event.${reactionEventIndex}.route_of_exposure`)
                            }, {
                              default: _withCtx(({ name, terminology, value, setValue, errors, validate, required }) => [
                                _createVNode(_unref(TerminologySearch), { terminology: terminology }, {
                                  default: _withCtx(({ search, searching, results, error: terminologySearchError }) => [
                                    _createVNode(_unref(MedKitSearch), {
                                      "model-value": value ? { label: value['|value'], value: value } : undefined,
                                      error: terminologySearchError ?? errors[0],
                                      label: name,
                                      "is-loading": searching,
                                      options: results.map(result => ({
                            label: result['|value'],
                            value: result,
                          })),
                                      class: "col-span-12 md:col-span-6 lg:col-span-8",
                                      required: required,
                                      "onUpdate:query": search,
                                      "onUpdate:modelValue": ($event: any) => (setValue($event ? ($event as SearchOption).value : undefined)),
                                      onInput: validate
                                    }, null, 8, ["model-value", "error", "label", "is-loading", "options", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                                  ]),
                                  _: 2
                                }, 1032, ["terminology"])
                              ]),
                              _: 2
                            }, 1032, ["path"]),
                            _createVNode(_unref(DvCodedText), {
                              path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.reaction_event.${reactionEventIndex}.severity_of_reaction`)
                            }, {
                              default: _withCtx(({ name, options, selected, setSelected, errors, validate, required }) => [
                                _createVNode(_unref(MedKitSelect), {
                                  error: errors[0],
                                  label: name,
                                  "model-value": selected,
                                  options: options,
                                  required: required,
                                  class: "col-span-12 md:col-span-6 lg:col-span-4",
                                  "onUpdate:modelValue": setSelected,
                                  onInput: validate
                                }, null, 8, ["error", "label", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
                              ]),
                              _: 2
                            }, 1032, ["path"]),
                            _createVNode(_unref(DvDateTime), {
                              path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.reaction_event.${reactionEventIndex}.onset_of_reaction`)
                            }, {
                              default: _withCtx(({ name, value, setValue, errors, validate, required }) => [
                                _createVNode(_unref(MedKitDateTimeField), {
                                  "date-input-only": "",
                                  error: errors[0],
                                  label: name,
                                  "model-value": value,
                                  class: "col-span-12 md:col-span-6 lg:col-span-4",
                                  required: required,
                                  "onUpdate:modelValue": setValue,
                                  onInput: validate
                                }, null, 8, ["error", "label", "model-value", "required", "onUpdate:modelValue", "onInput"])
                              ]),
                              _: 2
                            }, 1032, ["path"]),
                            _createVNode(_unref(DvText), {
                              path: props.path.add(`adverse_reaction_risk.${adverseReactionRiskIndex}.reaction_event.${reactionEventIndex}.reaction_comment`)
                            }, {
                              default: _withCtx(({ name, value, setValue, errors, validate, validateIfAlreadyValidated, required }) => [
                                _createVNode(_unref(MedKitTextField), {
                                  class: "col-span-12 md:col-span-6 lg:col-span-8",
                                  multiline: "",
                                  error: errors[0],
                                  label: name,
                                  "model-value": value,
                                  required: required,
                                  "onUpdate:modelValue": setValue,
                                  onInput: validateIfAlreadyValidated,
                                  onBlur: validate
                                }, null, 8, ["error", "label", "model-value", "required", "onUpdate:modelValue", "onInput", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["path"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["path"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["path", "present-if"])
    ]),
    _: 1
  }))
}
}

})